module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Drivmedelsguiden")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.target) ? _c('div', {
    staticClass: "row button-row"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.scrollDown
    }
  }, [_vm._v("Jämför priser direkt")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row article-row"
  }, [_c('article', [_vm._v("Här kan du enkelt jämföra aktuella drivmedelspriser mellan olika aktörer och se hur valet påverkar den totala drivmedelskostnaden per år – för en eller flera företagsbilar.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a0abc9f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/views/header.vue
// module id = 284
// module chunks = 1